import React, { useEffect, useState } from "react";
import { Tab, Table } from "react-bootstrap";
import "./Portfolio.css";
import { getBelowGraphData } from "../../../../../utils/apis/below_graph_data/below_graph";
import CustomPaginate from "../../../../common_components/custompaginate/CustomPaginate";
import Close_modal from "../../../../common_components/common_modal/close_modal/Close_modal";
import Delete_modal from "../../../../common_components/common_modal/delete_modal/Delete_modal";

const Portfolio = (companyId) => {

  // const [activeBtn, setActiveBtn] = useState("Open");

  const [modalShow, setModalShow] = useState(false);
  const [modalShowDelete, setModalShowDelete] = useState(false);
  // const [closeTradeId, setCloseTradeId] = useState("");

  const company_id = companyId.companyId;
  const NewlatestAmount = Number(companyId.latestAmount);
  const belowGraphData = Number(companyId?.belowGraphData?.data);
  const closeTradeId = companyId.closeTradeId;
  const setCloseTradeId = companyId.setCloseTradeId;
  const ActiveBtn = companyId.activeBtn;






  return (
    <section className="data_tabs_Section">
      <div className="tabs_btn_holder">
        <button
          className={`Blue_White_Gradient_Btn open_btn ${
            companyId.activeBtn === "Open" ? "active" : ""
          }`}
          type="button"
          onClick={() => companyId.setActiveBtn("Open")}
        >
          <p className="btn_text">Open</p>
        </button>

        <button
          className={`Blue_White_Gradient_Btn pending_btn ${
            companyId.activeBtn === "Pending" ? "active" : ""
          }`}
          type="button"
          onClick={() => companyId.setActiveBtn("Pending")}
        >
          <p className="btn_text">Pending</p>
        </button>

        <button
          className={`Blue_White_Gradient_Btn closed_btn ${
            companyId.activeBtn === "Close" ? "active" : ""
          }`}
          type="button"
          onClick={() => companyId.setActiveBtn("Close")}
        >
          <p className="btn_text">Closed</p>
        </button>
      </div>

      <div className="trade_table_container">
        <Table responsive variant="dark" className="trade_table">
          <thead>
            <tr>
              <th>Open</th>
              <th>Type</th>
              <th>Volume. Lot</th>
              <th>Open Price</th>
              <th>Current Price</th>
              <th>{ActiveBtn} Time</th>
              {ActiveBtn == "Open" && <th>P/L, $</th>}
              <th>
                {{
                  Open: "Close Trade",
                  Pending: "Cancel Trade",
                }[companyId.activeBtn] || ""}
              </th>
            </tr>
          </thead>
          <tbody>
            {companyId?.belowGraphData?.data?.map((trade, idx) => {
              const quantity = trade.quantity || 0;
              const pricePerUnit = trade.amount / quantity || 0;
              const currentPrice = NewlatestAmount || 0;

              let profitLoss = 0;

              if (trade.type === "buy") {
                profitLoss = (currentPrice - pricePerUnit) * quantity;
              } else if (trade.type === "sell") {
                profitLoss = (pricePerUnit - currentPrice) * quantity;
              }

              return (
                <tr key={idx}>
                  <td>{trade.Company?.name}</td>
                  <td className="type-buy">{trade.type}</td>
                  <td>{quantity}</td>
                  <td>{pricePerUnit.toFixed(2)}</td>
                  <td>{currentPrice.toFixed(2)}</td>
                  <td>
                    {new Date(trade.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </td>
                  {ActiveBtn == "Open" && (
                    <td
                      className={
                        profitLoss >= 0 ? "positive-pl" : "negative-pl"
                      }
                    >
                      {profitLoss >= 0 ? "+" : "-"} $
                      {Math.abs(profitLoss || 0).toFixed(2)}
                    </td>
                  )}
                  <td>
                    {companyId.activeBtn === "Open" ? (
                      <button
                        className="closebtn"
                        onClick={() => {
                          companyId?.showClsoeModal();
                          companyId?.onHide();
                          companyId?.setQuantity(trade?.quantity);
                          // setCloseTradeId(trade.id);
                          setCloseTradeId(trade.id);
                          if (companyId?.getGraphData) {
                            companyId?.getGraphData();
                          }
                        }}
                      >
                        Close
                      </button>
                    ) : companyId.activeBtn === "Pending" ? (
                      <button
                        className="closebtn"
                        onClick={() => {
                          companyId?.showDeleteModal();
                          companyId?.onHide();
                          setCloseTradeId(trade.id);
                        }}
                      >
                        Cancel
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      {/* <CustomPaginate
        currentPage={companyId.belowGraphData?.current_page}
        totalPages={companyId.belowGraphData?.total_pages}
        handlePageChange={companyId.handlePageChange}
      /> */}

      {/* <Close_modal
        show={modalShow}
        closeTradeId={closeTradeId}
        amount={NewlatestAmount}
        onHide={() => setModalShow(false)}
      /> */}

      {/* <Delete_modal
        show={modalShowDelete}
        closeTradeId={closeTradeId}
        amount={NewlatestAmount}
        onHide={() => setModalShowDelete(false)}
      /> */}
    </section>
  );
};

export default Portfolio;
